import {GetUser, SetUser, RemoveUser, GetOrg, SetOrg} from '../util/Helper';
import moment from "moment"
//moment.utc().format('YYYY-MM-DD HH:mm:ss ZZ'),
var API_URL = "https://dev-api-binderdrop.azurewebsites.net/";



export async function getAccounts() {
    var headers = await getHeaders();

    return fetch(API_URL+"companies", {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error); return [];});
}

export async function getCompanyList() {
    var headers = await getHeaders();

    return fetch(API_URL+"companies/list", {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error); return [];});
}

export async function getBrokers() {
    var headers = await getHeaders();

    return fetch(API_URL+"brokers", {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error); return [];});
}

export async function getInsurers() {
    var headers = await getHeaders();

    return fetch(API_URL+"insurers", {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error); return [];});
}

export async function getAccount(id) {
    var headers = await getHeaders();

    return fetch(API_URL+"companies/"+id, {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}

export async function getBroker(id) {
    var headers = await getHeaders();
    
    return fetch(API_URL+"brokers/"+id, {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}

export async function getInsurer(id) {
    var headers = await getHeaders();
    
    return fetch(API_URL+"insurers/"+id, {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}



export async function createTower(tower) {
    var headers = await getHeaders();

    var body = {
        companyId:tower.company.companyId,
        brokerId:tower.broker.brokerId,
        effectiveDate:tower.effectiveDate,
        expirationDate:tower.expirationDate,
    };
    
    return fetch(API_URL+"towers", {
        method: 'POST',
        body:JSON.stringify(body),
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}

export async function deleteTower(tower) {
    var headers = await getHeaders();

    
    return fetch(API_URL+"towers/"+tower.towerId, {
        method: 'DELETE',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}

export async function getTowerPDF(base64) {
    var headers = await getHeaders();

    var body = {base64};
    
    return fetch(API_URL+"binder/pdf2tower", {
        method: 'POST',
        body:JSON.stringify(body),
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}


export async function getTower(id) {
    var headers = await getHeaders();
    
    return fetch(API_URL+"towers/"+id, {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        if(json.policies){
            json.policies.reverse();
        }
        return json;
    }).catch((error) => { console.warn("error", error);});
}

export async function getTowers(companyId, brokerId, insurerId) {
    var headers = await getHeaders();
    
    var _paramString = "";
    if(companyId) _paramString = "?companyId="+companyId;
    if(brokerId) _paramString = "?brokerID="+brokerId;
    if(insurerId) _paramString = "?insurerID="+insurerId;

    return fetch(API_URL+"towers/search"+_paramString, {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        /*
        if(json.policies){
            json.policies.reverse();
        }
        */
        return json;
    }).catch((error) => { console.warn("error", error);});
}




export async function createPolicy(policy, towerID) {
    var headers = await getHeaders();

    var body = policy;
    body.insurerId = policy.insurer.insurerId;
    body.towerId = towerID;
    if(!body.liabilityShareLimit) delete body.liabilityShareLimit;
    if(!body.retention) delete body.retention;
    
    return fetch(API_URL+"policies", {
        method: 'POST',
        body:JSON.stringify(body),
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}

export async function updatePolicy(policy) {
    var headers = await getHeaders();

    var body = policy;
    //body.insurerId = policy.insurer.insurerId;
    
    return fetch(API_URL+"policies/"+policy.policyId, {
        method: 'PUT',
        body:JSON.stringify(body),
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}

export async function deletePolicy(policy) {
    var headers = await getHeaders();

    return fetch(API_URL+"policies/"+policy.policyId, {
        method: 'DELETE',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}


export async function getPolicy(id) {
    var headers = await getHeaders();
    
    return fetch(API_URL+"policies/"+id, {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}










export async function getPolicyPDF(base64) {
    var headers = await getHeaders();

    var body = {base64};
    
    return fetch(API_URL+"binder/pdf2Policy", {
        method: 'POST',
        body:JSON.stringify(body),
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}





export async function getBenchmarkData(sector, minMarketCap, maxMarketCap, companyId) {
    var headers = await getHeaders();
    
    var _paramString = "?sector="+(sector || "")+"&minMarketCap="+(minMarketCap || "")+"&maxMarketCap="+(maxMarketCap || "")+"&companyId="+(companyId || "");

    return fetch(API_URL+"benchmarking"+_paramString, {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        return json;
    }).catch((error) => { console.warn("error", error);});
}

export async function getOrganization() {
    var org = GetOrg();
    if(org) return org;

    var headers = await getHeaders();
    
    return fetch(API_URL+"organizations/mine", {
        method: 'GET',
        headers,
    }).then((response) => response.json()).then((json) => {
        SetOrg(json);
        return json;
    }).catch((error) => { console.warn("error", error);});
}

/***************Authentication***********/

export async function login(user, password) {
    var headers = await getHeaders();

    var body = {user, password};
    
    return fetch(API_URL+"auth", {
        method: 'POST',
        body:JSON.stringify(body),
        headers,
    }).then((response) => response.json()).then((json) => {
        SetUser(json);
        //set cookie with response data
        return json;
    }).catch((error) => { console.warn("error", error);});
}





/********Helpers***************************/
async function getHeaders() {
    var user = GetUser();

    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    
    if (user && user.access_token !== undefined) {
      headers['Authorization'] = 'Bearer ' + user.access_token
    }

    return headers
}


